/**
* Created by kongwm.kong on 2017/7/21.
*/
<template>
    <div class="layout_n">
        <div class="promise_page_wrap">
            <div class="content">
                <div class="title">提醒</div>
                <p class="ps" v-if=" auditStatus== 3 ">
                    在您开始浏览数据以及操作以前，请先撰写产品承诺函，加盖贵公司公章后上传文件，
                    上传成功后请等待人工审核，审核通过后方可进行下一步对数据的操作，如你在注册后14天内未上传承诺函，我们会将该账号进行回收。
                </p>
                <p class="ps" v-else-if="auditStatus == -1">
                    您此前上传的产品承诺函审核未通过，具体原因已以短信方式告知，您也可以在消息中心查看详情。

                    如承诺函在{{timeDay}}天内未上传并完成审核，我们将对当前账号进行回收，请知悉！
                </p>
                <p class="ps" v-else-if="auditStatus == 0">
                    您的产品承诺函正在审核中，审核通过后方可进行进一步操作。我们将于一个工作日内完成审核，并以短信的方式通知您。
                </p>
                <p class="go_comment">
                    产品承诺函请点此链接获取：
                    <a target="_blank" href="https://jfz-stock.oss-cn-hangzhou.aliyuncs.com/common/prod/%E9%87%91%E6%96%A7%E5%AD%90%E4%BA%A7%E5%93%81%E4%BF%9D%E8%AF%81%E6%89%BF%E8%AF%BA%E5%87%BD%E6%A8%A1%E6%9D%BF.docx">产品保证承诺函模板</a>
                </p>
                <div class="btn" v-show="auditStatus != 0 && auditStatus != 1"><up-load @showSmallImg="showSmallImg" :isValidSize="false"  :postURL="postURL"></up-load></div>
            </div>
        </div>
        <upload-suc></upload-suc>
    </div>
</template>
<script>
    import uploadSuc  from '../../components/modal/uploadSuc';
    import upLoad from '../../components/common/upload';
    export default {
        components:{
            upLoad,
            uploadSuc
        },
        data(){
            return {
                postURL: "/account/promiseFile",
            }
        },
        computed:{
            auditStatus(){
                let userData = this.$store.state.userData;
                if(userData != null && userData.promiseFileInfoVo.auditStatus !=null){
                   return  userData.promiseFileInfoVo.auditStatus;
                }
                return 3;
            },
            timeDay(){
                let userData = this.$store.state.userData;
                if(userData != null && userData.promiseFileInfoVo.remainingDays !=null){
                    return  userData.promiseFileInfoVo.remainingDays;
                }
                return 14;
            }
        },
        created(){
            this.$store.commit('getLoginInfo');
        },
        methods:{
            /*显示缩略图*/
            showSmallImg(data){
                this.show();
                this.$store.commit('changeProImg', data);
            },
            show(){
                this.$modal.show('upload-success');
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .layout_n{
        margin-top:30px;
        margin-bottom: 50px;
    }
    .promise_page_wrap{
        height:1356px;
        background: #fff;
        padding-top:106px;
        .content{
            width:702px;
            margin: 0 auto;
            .title{
                font-size: 18px;
                color: $c_ff5;
                text-align: center;
                margin-bottom: 24px;
            }
            .ps{
                font-size: 16px;
                color:$c_ff5;
                letter-spacing: 0.2px;
                line-height: 24px;
                margin-bottom: 24px;
            }
            .go_comment{
                font-size: 16px;
                color: #1C3900;
                letter-spacing: 0;
                line-height: 24px;
                margin-bottom: 64px;
                a{
                    color: $btn_408;
                }
            }
            .btn{
                height:50px;
                width:204px;
                background-color:$btn_408;
                color:#fff;
                font-size: 18px;
                font-weight:bold;
                line-height:50px;
                text-align: center;
                cursor: pointer;
                margin: 0 auto;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/views/user/promise.vue